import { render } from "./CustomRules.vue?vue&type=template&id=25fd2c62"
import script from "./CustomRules.vue?vue&type=script&lang=js"
export * from "./CustomRules.vue?vue&type=script&lang=js"

import "./CustomRules.vue?vue&type=style&index=0&id=25fd2c62&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__